<template>
  <div>
    <h1 class="text-4xl sm:text-6xl mb-2 sm:mb-6">
      {{ uncolored }}<br />
      <span :style="{ color }">{{ colored }}</span>
    </h1>
    <p
      class="text-normal sm:text-lg font-light text-white text-opacity-75 max-w-xl"
    >
      {{ description }}
    </p>
    <img
      :id="id"
      class="w-full mt-8 sm:mt-16 transition-opacity ease-linear duration-250"
      :src="img"
      :alt="alt"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "FeatureSection",
  props: {
    uncolored: String,
    colored: String,
    description: String,
    img: String,
    alt: String,
    color: String,
    id: String
  }
});
</script>
